var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export const TEXT = {
    DEFAULT_ELEMENT: 'span',
    DEFAULT_VARIANT: 'span',
    ELEMENTS: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p',
        'span',
        'small',
        'a',
        'label',
    ],
    VARIANTS: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p',
        'caption',
        'meta',
        'link',
    ],
};
export const TextComponent = (_a) => {
    var { as, children, variant, className, gutterTop, gutterBottom, bold, italic, element } = _a, rest = __rest(_a, ["as", "children", "variant", "className", "gutterTop", "gutterBottom", "bold", "italic", "element"]);
    const Element = as || element || TEXT.DEFAULT_ELEMENT;
    const elementToVariant = () => TEXT.VARIANTS.includes(Element.toString())
        ? Element.toString()
        : TEXT.DEFAULT_VARIANT;
    return (_jsx(Element, Object.assign({ className: [
            'c-typography',
            `c-typography__variant--${variant !== null && variant !== void 0 ? variant : elementToVariant()}`,
            ...(className ? [className] : []),
            ...(italic ? ['u-italic'] : []),
            ...(bold ? ['u-bold'] : []),
            ...(gutterTop === false ? ['u-margin__top--0'] : []),
            ...(gutterBottom === false ? ['u-margin__bottom--0'] : []),
        ].join(' ') }, rest, { children: children })));
};
export const Typography = TextComponent;
export const Text = TextComponent;
